/*
 * @Author: DZH Co.,Ltd.
 * @Date: 2025-04-30 15:26:20
 * @LastEditors: DZH Co.,Ltd
 * @LastEditTime: 2025-06-05 16:38:46
 * @Description:
 * Copyright (c) 2025 by DZH Co.,Ltd., All Rights Reserved.
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import Vuex from "vuex";
import * as echarts from "echarts";
import Mixins from "@/mixins/mixins.js";
import store from "./vuex-store";
import { Base64 } from "js-base64";
// common css
import "@/assets/css/reset.css";
import "@/assets/scss/common.scss";
// dzhToken
import Dzhyun from "dzhyunjs";
import common from "@/common/common.js";
// 兼容低版本
import "babel-polyfill";
import Es6Promise from "es6-promise";
import "core-js/stable";
import "regenerator-runtime/runtime";
Es6Promise.polyfill();

// import VConsole from 'vconsole' //引入
// new VConsole() //初始化

import {
  List,
  NavBar,
  Col,
  Row,
  Divider,
  Empty,
  Loading,
  Toast,
  Cell,
  Icon,
  Dialog,
  Field,
} from "vant";
Vue.use(List);
Vue.use(NavBar);
Vue.use(Col);
Vue.use(Row);
Vue.use(Divider);
Vue.use(Empty);
Vue.use(Loading);
Vue.use(Toast);
Vue.use(Cell);
Vue.use(Icon);
Vue.use(Dialog);
Vue.use(Field);

Vue.use(Vuex);
Vue.prototype.$base64 = Base64;
Vue.prototype.$http = axios;
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
Vue.mixin(Mixins);

// 定义全局变量dzhyun
window.dzhyun = new Dzhyun({
  address: window.config.yunwsurl,
  dataType: "json",
  token: common.YunToken(
    window.config.appid,
    window.config.secretKey,
    window.config.shortid,
    24 * 3600
  ),
});

window.addEventListener('message', event => {
  if (event.data.action === 'setDzhAppJs') {
    window.DzhAppJs = event.data.data
  }
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
